var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNoteIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258.978,
    height: 257.734,
    viewBox: "0 0 258.978 257.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6e6e6;}.b{fill:#fff;}.c{fill:#f2f2f2;}.d{fill:#ccc;}.e{fill:#ffb8b8;}.f{fill:#2f2e41;}.g{fill:#6c63ff;}.h{fill:rgba(0,0,0,0.6);opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M634.9,279.208H592.4a6.118,6.118,0,0,1-4.833-2.342h0a6.2,6.2,0,0,1-1.16-5.313,107.482,107.482,0,0,0,0-49.919,6.2,6.2,0,0,1,1.16-5.313,6.118,6.118,0,0,1,4.833-2.342H634.9a6.2,6.2,0,0,1,6.1,5.2,180.154,180.154,0,0,1,0,54.829,6.2,6.2,0,0,1-6.1,5.2Z",
    transform: "translate(-464.079 -210.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M595.2,219.978a2.939,2.939,0,0,0-2.321,1.124,3.017,3.017,0,0,0-.562,2.587,110.692,110.692,0,0,1,0,51.411,3.015,3.015,0,0,0,.561,2.587h0a2.938,2.938,0,0,0,2.321,1.124h42.507a2.976,2.976,0,0,0,2.937-2.488,176.968,176.968,0,0,0,0-53.858,2.976,2.976,0,0,0-2.937-2.488Z",
    transform: "translate(-466.882 -213.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M637.8,242.131H615.495a3.2,3.2,0,0,1-3.2-3.2v-1.25a3.2,3.2,0,0,1,3.2-3.2H637.8a3.2,3.2,0,0,1,3.2,3.2v1.25A3.2,3.2,0,0,1,637.8,242.131Z",
    transform: "translate(-476.252 -220.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M637.8,271.756H615.495a3.2,3.2,0,0,1-3.2-3.2v-1.25a3.2,3.2,0,0,1,3.2-3.2H637.8a3.2,3.2,0,0,1,3.2,3.2v1.25a3.2,3.2,0,0,1-3.2,3.2Z",
    transform: "translate(-476.252 -234.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M637.8,301.382H615.495a3.2,3.2,0,0,1-3.2-3.2v-1.25a3.2,3.2,0,0,1,3.2-3.2H637.8a3.2,3.2,0,0,1,3.2,3.2v1.25A3.2,3.2,0,0,1,637.8,301.382Z",
    transform: "translate(-476.252 -248.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M784.9,355.208H742.4a6.118,6.118,0,0,1-4.833-2.342h0a6.2,6.2,0,0,1-1.16-5.313,107.481,107.481,0,0,0,0-49.919,6.2,6.2,0,0,1,1.16-5.313,6.118,6.118,0,0,1,4.833-2.342H784.9a6.2,6.2,0,0,1,6.1,5.2,180.154,180.154,0,0,1,0,54.829,6.2,6.2,0,0,1-6.1,5.2Z",
    transform: "translate(-534.12 -246.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M745.2,295.978a2.939,2.939,0,0,0-2.321,1.124,3.017,3.017,0,0,0-.562,2.587,110.691,110.691,0,0,1,0,51.411,3.015,3.015,0,0,0,.561,2.587h0a2.938,2.938,0,0,0,2.321,1.124h42.507a2.976,2.976,0,0,0,2.937-2.488,176.968,176.968,0,0,0,0-53.858,2.976,2.976,0,0,0-2.937-2.488Z",
    transform: "translate(-536.923 -249.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M625.669,441.241H583.162a6.384,6.384,0,0,1-5.042-2.444,6.46,6.46,0,0,1-1.21-5.541,107.215,107.215,0,0,0,0-49.795,6.461,6.461,0,0,1,1.21-5.54,6.384,6.384,0,0,1,5.042-2.444h42.507a6.464,6.464,0,0,1,6.361,5.426,180.416,180.416,0,0,1,0,54.911A6.464,6.464,0,0,1,625.669,441.241Z",
    transform: "translate(-459.643 -286.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M787.8,333.131H765.495a3.2,3.2,0,0,1-3.2-3.2v-1.25a3.2,3.2,0,0,1,3.2-3.2H787.8a3.2,3.2,0,0,1,3.2,3.2v1.25a3.2,3.2,0,0,1-3.2,3.2Z",
    transform: "translate(-546.294 -262.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M787.8,362.756H765.495a3.2,3.2,0,0,1-3.2-3.2v-1.25a3.2,3.2,0,0,1,3.2-3.2H787.8a3.2,3.2,0,0,1,3.2,3.2v1.25A3.2,3.2,0,0,1,787.8,362.756Z",
    transform: "translate(-546.294 -276.825)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 12.26,
    cy: 12.26,
    r: 12.26,
    transform: "translate(132.631 109.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M628.22,428.614h-4.264v-4.264a1.6,1.6,0,1,0-3.2,0v4.264h-4.264a1.6,1.6,0,0,0,0,3.2h4.264v4.264a1.6,1.6,0,1,0,3.2,0v-4.264h4.264a1.6,1.6,0,1,0,0-3.2Z",
    transform: "translate(-477.466 -308.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M636.181,217.312H613.793a2.4,2.4,0,0,1-2.4-2.4v-4.264a2.4,2.4,0,0,1,2.4-2.4h22.388a2.4,2.4,0,0,1,2.4,2.4v4.264A2.4,2.4,0,0,1,636.181,217.312Z",
    transform: "translate(-475.831 -208.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M788.181,294.312H765.793a2.4,2.4,0,0,1-2.4-2.4v-4.264a2.4,2.4,0,0,1,2.4-2.4h22.389a2.4,2.4,0,0,1,2.4,2.4v4.265a2.4,2.4,0,0,1-2.4,2.4Z",
    transform: "translate(-546.806 -244.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M88.6,448.98H95.13l2.043-25.207h-8.58Z",
    transform: "translate(-41.368 -197.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M442.552,675.308h12.871a8.2,8.2,0,0,1,8.2,8.2v.266H442.552Z",
    transform: "translate(-396.992 -426.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M22.6,448.98H29.13l3.109-25.207H22.594Z",
    transform: "translate(-10.55 -197.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M376.552,675.308h12.871a8.2,8.2,0,0,1,8.2,8.2v.266H376.552Z",
    transform: "translate(-366.174 -426.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M377.228,579.825a2.655,2.655,0,0,1-1.8-.7h0a2.644,2.644,0,0,1-.861-1.885L371.947,483.3l37.213,9.3,11.482,34.445a37.56,37.56,0,0,1,1.89,13.766l-1.426,33.389a2.663,2.663,0,0,1-2.662,2.537H412.2a2.678,2.678,0,0,1-2.641-2.308L405.1,537.579a20.162,20.162,0,0,0-2.949-8.083l-8.779-13.9a.533.533,0,0,0-.98.219l-6.89,61.349a2.662,2.662,0,0,1-2.5,2.344l-5.625.313C377.329,579.823,377.279,579.825,377.228,579.825Z",
    transform: "translate(-364.024 -336.684)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 13.092,
    cy: 13.092,
    r: 13.092,
    transform: "translate(25.852 59.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M406.741,445.1a2.7,2.7,0,0,1-.668-.085h0l-36.922-9.467a2.664,2.664,0,0,1-1.953-3.1l8.479-45.678a16.639,16.639,0,0,1,9.728-12.015,16.052,16.052,0,0,1,15.067,1.106c.517.323,1.038.674,1.547,1.045a16.5,16.5,0,0,1,6.705,13.076L409.4,442.4a2.669,2.669,0,0,1-2.659,2.7Z",
    transform: "translate(-361.782 -285.356)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M377.22,485.38a5.36,5.36,0,0,1,2.246-7.906L377.824,458.5l8.7,4.717.225,17.3a5.389,5.389,0,0,1-9.532,4.869Z",
    transform: "translate(-366.053 -325.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M376.957,436.366a2.937,2.937,0,0,1-2.845-2.217l-4.277-17a25.251,25.251,0,0,1,2-17.663l8.96-17.528a8.284,8.284,0,0,1,10.026-5.874,8.186,8.186,0,0,1,5.051,3.785,8.3,8.3,0,0,1,.882,6.35L384,414.746l.151,17.077a2.942,2.942,0,0,1-1.911,2.774l-4.268,1.585a2.922,2.922,0,0,1-1.019.184Z",
    transform: "translate(-362.68 -286.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M480.9,476.989a5.36,5.36,0,0,1-4.527-6.86l-15.455-11.135,9.252-3.519,13.258,11.114a5.389,5.389,0,0,1-2.528,10.4Z",
    transform: "translate(-405.566 -323.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M449.993,434.731a2.945,2.945,0,0,1-1.313-.31l-15.672-7.845a25.257,25.257,0,0,1-12.079-13.042l-7.44-18.226a8.286,8.286,0,0,1,2.088-11.431,8.184,8.184,0,0,1,6.178-1.356,8.3,8.3,0,0,1,5.374,3.471l13.3,28.273,13.042,11.025a2.941,2.941,0,0,1,.856,3.258l-1.583,4.269a2.932,2.932,0,0,1-2.749,1.913Z",
    transform: "translate(-382.753 -289.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M414.662,344.057c.7.3,2.12-5.239,1.482-6.347-.949-1.649-.893-1.637-1.523-2.728a3.162,3.162,0,0,1,.045-3.544c.816-.96,2.7-.832,3.076.371-.24-2.286,2.021-4.123,4.261-4.639s4.6-.2,6.853-.655c2.613-.533,5.332-2.724,4.29-5.6a4.049,4.049,0,0,0-.789-1.3,9.984,9.984,0,0,0-4.537-2.492c-3.428-1.163-6.949-2.341-10.566-2.213a15.351,15.351,0,0,0-13.564,9.92,13.951,13.951,0,0,0-.578,2.146,14.389,14.389,0,0,0,8.932,15.8Z",
    transform: "translate(-378.468 -258.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.9,241.591l.3-17.553,9.3-18.695-7.463,19.19Z",
    transform: "translate(-18.164 -95.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M516.449,496.764,477.2,480.455a6.118,6.118,0,0,1-3.564-4.017h0a6.2,6.2,0,0,1,.967-5.352,107.482,107.482,0,0,0,19.153-46.1,6.2,6.2,0,0,1,3.11-4.461,6.118,6.118,0,0,1,5.361-.309l39.254,16.309a6.2,6.2,0,0,1,3.636,7.142A180.156,180.156,0,0,1,524.075,494.3a6.2,6.2,0,0,1-7.627,2.462Z",
    transform: "translate(-411.395 -307.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M503.8,425.974a2.939,2.939,0,0,0-2.575.147,3.017,3.017,0,0,0-1.511,2.174,110.693,110.693,0,0,1-19.725,47.476,3.015,3.015,0,0,0-.474,2.6h0a2.938,2.938,0,0,0,1.712,1.929l39.254,16.309a2.976,2.976,0,0,0,3.666-1.171,176.969,176.969,0,0,0,20.664-49.736,2.976,2.976,0,0,0-1.757-3.424Z",
    transform: "translate(-414.198 -309.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M544.61,480.385l-20.6-8.558a3.2,3.2,0,0,1-1.726-4.181l.479-1.154a3.2,3.2,0,0,1,4.181-1.726l20.6,8.558a3.2,3.2,0,0,1,1.726,4.181l-.48,1.154a3.2,3.2,0,0,1-4.181,1.726Z",
    transform: "translate(-434.108 -327.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M533.243,507.744l-20.6-8.558A3.2,3.2,0,0,1,510.918,495l.479-1.154a3.2,3.2,0,0,1,4.181-1.726l20.6,8.559a3.2,3.2,0,0,1,1.726,4.181l-.479,1.154A3.2,3.2,0,0,1,533.243,507.744Z",
    transform: "translate(-428.801 -340.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M559.581,440.814a2.393,2.393,0,0,1-.9-.176l-20.756-8.392a2.4,2.4,0,0,1-1.325-3.123l1.6-3.954a2.4,2.4,0,0,1,3.123-1.325l20.756,8.392a2.4,2.4,0,0,1,1.325,3.123l-1.6,3.954A2.4,2.4,0,0,1,559.581,440.814Z",
    transform: "translate(-440.826 -308.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M432.244,690.816H357.616a.533.533,0,0,1,0-1.066h74.628a.533.533,0,0,1,0,1.066Z",
    transform: "translate(-357.083 -433.082)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteIllustration);
export default __webpack_public_path__ + "static/media/add-note-illustration.f6b9abf9662f83e71ae5d62919352c3a.svg";
export { ForwardRef as ReactComponent };